import { Pipe, PipeTransform } from '@angular/core';
import { Claim } from './claim';

@Pipe({
  name: 'claimSearch'
})

export class ClaimSearchPipe implements PipeTransform {
  date: Date;

  transform(
    items: Claim[], 
    countrySearch: string, 
    claimDateFrom: Date, 
    claimDateTo: Date, 
    claimStatusSearch: string, 
    employeeIdSearch: string, 
    employeeNameSearch: string, 
    receiptNoSearch: string, 
    claimIdSearch: string
  ) {
    if (!items || !items.length) {
      return items;
    }

    return items.filter(item => this.matches(item, {
      countrySearch,
      claimDateFrom,
      claimDateTo,
      claimStatusSearch,
      employeeIdSearch,
      employeeNameSearch,
      receiptNoSearch,
      claimIdSearch
    }));
  }

  private matches(item: Claim, criteria: any): boolean {
    const { countrySearch, claimDateFrom, claimDateTo, claimStatusSearch, employeeIdSearch, employeeNameSearch, receiptNoSearch, claimIdSearch } = criteria;

    if (countrySearch && !this.containsIgnoreCase(item.country, countrySearch)) {
      return false;
    }
    if (claimStatusSearch && !item.status.includes(claimStatusSearch)) {
      return false;
    }
    if (claimDateFrom && new Date(item.submissionDate) < claimDateFrom) {
      return false;
    }
    if (claimDateTo && new Date(item.submissionDate) >= this.addDays(claimDateTo, 1)) {
      return false;
    }
    if (employeeNameSearch && !this.containsIgnoreCase(item.employeeName, employeeNameSearch)) {
      return false;
    }
    if (employeeIdSearch && !this.containsIgnoreCase(item.employeeId, employeeIdSearch)) {
      return false;
    }
    if (receiptNoSearch && !this.containsIgnoreCase(item.receiptNo, receiptNoSearch)) {
      return false;
    }
    if (claimIdSearch && !item.claimId.toString().includes(claimIdSearch)) {
      return false;
    }
    return true;
  }

  private containsIgnoreCase(source: string, search: string): boolean {
    return source.toLowerCase().indexOf(search.toLowerCase()) !== -1;
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}
